import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5e982f70&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=5e982f70&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../viewport/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e982f70",
  null
  
)

export default component.exports